<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Gönüllü Listesi
            </h3>
        </div>
        <!-- <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-actions">
                <button class="btn btn-outline-dark ml-3" (click)="excelExport()">Excel oluştur</button>
                <a href="{{assetsPath + excelPath}}" target="_blank" class="btn btn-outline-success ml-3" *ngIf="excelPath">Excel indir</a>

            </div>
        </div> -->
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                <div class="form-group row">
                    <div class="col-4">
                        <label for="fullName" class="col-12 col-form-label">Ad soyad</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="fullName" name="fullName"
                                [(ngModel)]="filters.fullName" placeholder="Ad soyad">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="email" class="col-12 col-form-label">Email</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="email" name="email"
                                [(ngModel)]="filters.email" placeholder="Email">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="gender" class="col-12 col-form-label">Cinsiyet</label>
                        <div class="col-12">
                            <ng-select name="type" id="gender" labelForId="gender" bindValue="code"
                                [items]="genderTypes" bindLabel="text" [(ngModel)]="filters.gender"
                                placeholder="Seçiniz..">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-4">
                        <label for="companyName" class="col-12 col-form-label">Şirket adı</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="companyName" name="companyName"
                                [(ngModel)]="filters.companyName" placeholder="Şirket adı">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="position" class="col-12 col-form-label">Pozisyon</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="position" name="position"
                                [(ngModel)]="filters.position" placeholder="Pozisyon">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="phone" class="col-12 col-form-label">Telefon numarası</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="phone" name="phone"
                                [(ngModel)]="filters.phone" placeholder="Telefon numarası">
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-4">
                        <label for="universityId" class="col-12 col-form-label">Üniversite</label>
                        <div class="col-12">
                            <ng-select name="type" id="universityId" labelForId="universityId" bindValue="id"
                                [items]="universities" bindLabel="name" [(ngModel)]="filters.universityId"
                                placeholder="Seçiniz..">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="school" class="col-12 col-form-label">Okul</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="school" name="school"
                                [(ngModel)]="filters.school" placeholder="Okul adı">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="departmant" class="col-12 col-form-label">Bölüm</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="departmant" name="departmant"
                                [(ngModel)]="filters.departmant" placeholder="Bölüm adı">
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-4">
                        <label for="primaryCityId" class="col-12 col-form-label">Birincil Şehir</label>
                        <div class="col-12">
                            <ng-select name="type" id="primaryCityId" labelForId="primaryCityId" bindValue="id"
                                [items]="cities" bindLabel="name" [(ngModel)]="filters.primaryCityId"
                                placeholder="Seçiniz..">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="secondaryCityId" class="col-12 col-form-label">İkincil Şehir</label>
                        <div class="col-12">
                            <ng-select name="type" id="secondaryCityId" labelForId="secondaryCityId" bindValue="id"
                                [items]="cities" bindLabel="name" [(ngModel)]="filters.secondaryCityId"
                                placeholder="Seçiniz..">
                            </ng-select>
                        </div>
                    </div>
                </div>
                
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label for="endDate" class="col-12 col-form-label">&nbsp;</label>
                        <div class="col-12">
                            <button class="btn btn-outline-success" (click)="filterResults()">Filtrele</button>
                            <button class="btn btn-outline-danger ml-3" (click)="resetFilters()">Sıfırla</button>
                            <button class="btn btn-outline-dark ml-3" (click)="excelExport()">Excel oluştur</button>
                            <a href="{{assetsPath + excelPath}}" target="_blank" class="btn btn-outline-success ml-3" *ngIf="excelPath">Excel indir</a>
                            
                        </div>
                    </div>
                </div>
                <div class="row justify-content-end">
                    <button type="button" class="pagination-button" (click)="setFirstPage()"><<</button>
                    <button type="button" class="pagination-button" (click)="decrementPage()"><</button>
                    <!-- <button type="button" class="pagination-button active">1</button>
                    <button type="button" class="pagination-button">2</button>
                    <button type="button" class="pagination-button">3</button>
                    <button type="button" class="pagination-button">4</button> -->
                    <span class="pagination-text">{{currentPageNum*rowPerPage + 1}}-{{(currentPageNum+1)*rowPerPage}} of {{volunteers.length}}</span>
                    <button type="button" class="pagination-button" (click)="incrementPage()">></button>
                    <button type="button" class="pagination-button" (click)="setLastPage()">>></button>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Ad soyad</th>
                                <th>Email</th>
                                <th>Doğum tarihi</th>
                                <th>Telefon</th>
                                <th>Kayıt Tarihi</th>
                                <th>İşlem</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let volunteer of tableCardList;">
                                <td><a [routerLink]="['/view-profile/'+volunteer.id]" target="_blank">{{volunteer.displayName}}</a></td>
                                <td>{{volunteer.email}}</td>
                                <td>{{volunteer.birthDate}}</td>
                                <td>{{volunteer.phone}}</td>
                                <td>{{volunteer.creationDate}}</td>
                                <td><button class="btn btn-success mr-2"
                                    [routerLink]="['/view-profile/'+volunteer.id]"><i
                                    class="fa fa-info-circle"></i>Profili Görüntüle</button>
                                    <button class="btn btn-primary mr-2"
                                    [routerLink]="['/upgrade-user/'+volunteer.id]"><i
                                    class="fa fa-pen"></i>Rol Yükselt/Düşür</button></td>
                                    
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row justify-content-end">
                    <button type="button" class="pagination-button" (click)="setFirstPage()"><<</button>
                    <button type="button" class="pagination-button" (click)="decrementPage()"><</button>
                    <!-- <button type="button" class="pagination-button active">1</button>
                    <button type="button" class="pagination-button">2</button>
                    <button type="button" class="pagination-button">3</button>
                    <button type="button" class="pagination-button">4</button> -->
                    <span class="pagination-text">{{currentPageNum*rowPerPage + 1}}-{{(currentPageNum+1)*rowPerPage}} of {{volunteers.length}}</span>
                    <button type="button" class="pagination-button" (click)="incrementPage()">></button>
                    <button type="button" class="pagination-button" (click)="setLastPage()">>></button>
                </div>
            </div>
        </div>
    </div>
</div>